<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_EditNodeAlertRules')"
    width="760px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view warn-rule-form"
    @close="close"
  >
    <div class="main-content">
      <div style="width: fit-content">
        <div style="display: flex">
          <div style="display: flex;flex-direction: column;">
            <div class="section form-column content-wrapper">
              <el-form
                :disabled="readonly"
                label-width="100px"
                label-position="left"
              >
                <el-form-item :label="$t('CargoMsg.Cargo_WarningSwitch')">
                  <el-radio-group v-model="form.open">
                    <el-radio :label="1">{{ $t('CargoMsg.Cargo_StartAlert') }}</el-radio>
                    <el-radio :label="0">{{ $t('CargoMsg.Cargo_CloseAlert') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_WarningConditions')">
                  <cargo-advance-select
                    :default-value="form.warningDateField"
                    :static-options="alertTypes"
                    tag-value="code"
                    :cache="false"
                    filterable
                    filter-type="global"
                    style="width: 200px"
                    @parentCallBack="p=>{form.warningDateField=p.value}"
                  />
                </el-form-item>
                <el-form-item v-show="showNodeStatus" :label="$t('Sop.SelectTheNode')">
                  <cargo-advance-select
                    :default-value="form.triggerTrackingDetailUuid"
                    :static-options="completeNodeStatus"
                    :cache="false"
                    filterable
                    filter-type="global"
                    tag-value="trackingDetailUuid"
                    :custom-label="(item)=>`${item.codeCname}(${item.subCodeCname})`"
                    style="width: 200px"
                    @parentCallBack="p=>{form.triggerTrackingDetailUuid=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_WarningContent')">
                  <el-input v-model="form.content" style="width: 240px" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_AutoIgnoreMode')">
                  <el-radio-group v-model="form.ignoreType">
                    <el-radio :label="1">{{ $t('CargoMsg.Cargo_EarlyTimedIgnore') }}</el-radio>
                    <el-radio :label="0">{{ $t('CargoMsg.Cargo_TurnOffAutoIgnore') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_IgnoreTime')">
                  <div style="display: flex">
                    <el-input v-model="form.ignoreTime" :disabled="form.ignoreType === 0" type="number" style="width: 120px !important;" oninput="value=value.replace(/[^\d]/g,'')" />
                    <span style="margin-left: 5px">{{ $t('CargoMsg.Cargo_AutomaticallyIgnoreAfterHours') }}</span>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_RemarksInfo')">
                  <el-input v-model="form.remark" type="textarea" />
                </el-form-item>
              </el-form>
            </div>
            <div class="section form-column content-wrapper" style="margin-left: 0px;margin-top: 0px;flex-grow: 1;">
              <el-form
                :disabled="readonly"
                label-width="100px"
                label-position="left"
              >
                <span class="title">{{ $t('CargoMsg.Cargo_SetSOPNodeOfAlert') }}</span>
                <el-form-item :label="$t('CargoMsg.Cargo_SopTemplate')">
                  <el-input v-model="form.templateName" disabled />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_SopNode')">
                  <el-input v-model="form.trackingName" disabled />
                </el-form-item>
                <el-form-item :label="$t('Sop.nodeState')">
                  <el-input v-model="form.trackingDetailName" disabled />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_ApplicationScope')">
                  <el-radio-group v-model="ignoreMode" :disabled="!!form.triggerTrackingDetailUuid">
                    <el-radio :label="true" style="margin-bottom: 5px">{{ $t('CargoMsg.Cargo_ApplyToAllTemplates') }}</el-radio>
                    <el-radio :label="false">{{ $t('CargoMsg.Cargo_UseOnlyTheCurrentTemplate') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_DocumentNotification')">
                  <el-radio-group v-model="form.notifyJobType">
                    <el-radio style="margin-bottom: 5px" :label="0">{{ $t('CargoMsg.Cargo_NoticeOfEachBill') }}</el-radio>
                    <el-radio :label="1">{{ $t('CargoMsg.Cargo_NoNoticeOfTickets') }}</el-radio></el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="section form-column content-wrapper">
            <el-scrollbar style="height: 60vh;">
              <el-form
                :disabled="readonly"
                label-width="100px"
                label-position="left"
              >
                <span class="title">{{ $t('SystemMaintenance.SopTimeSetUp') }}</span>
                <div v-for="(item, index) in warningRuleItemList" :key="index" :style="{marginTop:index>0?'20px':'',paddingLeft:'20px'}">
                  <div style="margin-bottom: 5px;margin-left: -25px">
                    <span v-if="index + 1 === warningRuleItemList.length && warningRuleItemList.length !== 3" class="form-operator" @click="onAdd()"><i class="el-icon-circle-plus" /></span>
                    <span v-else class="form-operator" @click="onRemove(item, index)"><i class="el-icon-remove" /></span>
                    <el-select v-model="item.ruleItem" style="width: 100px; margin-right: 5px">
                      <el-option value="1" :label="$t('CargoMsg.Cargo_BringForward')" />
                      <el-option value="2" :label="$t('CargoMsg.Cargo_Postpone')" />
                    </el-select>
                    <el-input v-model="item.duration" type="number" oninput="value=value.replace(/[^\d]/g,'')" style="width: 50px; margin-right: 5px" />
                    <span>{{ $t('Pricing.Hour') }}</span>
                    <el-input-number v-model="item.minute" type="number" :min="0" :max="59" :step="1" :controls="false" style="width: 50px; margin-left: 5px; margin-right: 5px" />
                    <span>{{ $t('CargoMsg.Cargo_EarlyWarningReminder') }}</span>
                  </div>
                  <el-form-item :label="$t('CargoMsg.Cargo_WarningLevel')">
                    <el-radio-group v-for="item2 in levels" :key="item2.code" v-model="item.level">
                      <el-radio :label="item2.code" style="margin-right: 10px">{{ item2.chineseName }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <span class="title">{{ $t('CargoMsg.Cargo_SetAlertNotificationObject') }}</span>
                  <div style="margin-left: 10px">
                    <div>
                      <el-checkbox v-model="item._ext.hasDesignatedPost" @change="item.notifierRoles=''">{{ $t('CargoMsg.Cargo_DesignatedPost') }}</el-checkbox>
                    </div>
                    <el-checkbox-group :value="toArray(item.notifierRoles)" :disabled="!item._ext.hasDesignatedPost" @input="val=>{item.notifierRoles=toTxt(val)}">
                      <el-checkbox v-for="(item, index) in roles" :key="index" style="margin-top: 10px" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
                    </el-checkbox-group>
                    <div style="margin-top: 10px">
                      <el-checkbox v-model="item._ext.hasNotifierIds" @change="item.notifierIds=''">{{ $t('CargoMsg.Cargo_DesignatedPersonnel') }}</el-checkbox>
                      <cargo-advance-select
                        :select-type="selectTypeNames.basic_data_User"
                        :fields="['chineseName']"
                        :disabled="!item._ext.hasNotifierIds"
                        :callback-params="{key:'userList'}"
                        callback-method-type="value"
                        tag-value="userId"
                        tag-name="chineseName"
                        :filter-tag-names="['chineseName']"
                        :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                        :default-multiple-value="toArray(item.notifierIds)"
                        multiple
                        filterable
                        style="width:205px;margin-top: 10px"
                        options-width="230px"
                        @parentCallBack="p=>{item.notifierIds=toTxt(p.value)}"
                      />
                    </div>
                    <div style="margin-top: 10px">
                      <el-checkbox :value="!!item.enableMail" @input="val=>{item.enableMail=val?1:0}">{{ $t('Viewer.email') }}</el-checkbox>
                      <el-checkbox :value="!!item.enableWeChat" @input="val=>{item.enableWeChat=val?1:0}">{{ $t('CargoMsg.Cargo_Wechat') }}</el-checkbox>
                    </div>
                  </div>
                </div>
              </el-form>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button @click="close">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { saveWarningRule } from '@/api/sysManage/baseConfig/warnRuleConfiguration'
import { getLoading } from '@/utils/utilBaseElement'
import * as commonUtil from '@/utils/commonUtil'
import { deepClone } from '@/utils'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
export default {
  name: 'WarnRuleForm',
  components: { CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    source: {
      type: Object,
      default: () => {}
    },
    alertTypes: {
      type: Array,
      default: () => []
    },
    completeNodeStatus: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      form: {},
      trackingDetailForm: { innerConfig: {}},
      selectTypeNames: TYPE_NAMES,
      levels: Array.from(SystemConstants.LEVELS),
      roles: CargoOfRoleType.WARNING_ROLE_TYPES,
      isZh: this.$store.getters.language === 'zh',
      ignoreMode: false, // 应用范围，true 应用到所有模板，false 仅当前模板使用
      fullscreenLoading: null,
      showNodeStatus: false,
      warningRuleItemList: []
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
    'form.ignoreType': function(val) {
      if (val === 0) {
        this.form.ignoreTime = ''
      } else {
        this.form.ignoreTime = 24
      }
    },
    'form.warningDateField': function(val) {
      const showNodeStatus = this.changeWarningDateField(val)
      if (!showNodeStatus) {
        this.form.triggerTrackingDetailUuid = ''
      }
      this.showNodeStatus = showNodeStatus
    },
    'form.triggerTrackingDetailUuid': function(val) {
      if (val) {
        this.ignoreMode = false
      }
    }
  },
  mounted() {
    this.form = deepClone(this.source)
    // 预警条件为空的时候，warningDateField字段会有默认值0展示在选项框中
    if (this.alertTypes.length === 0) {
      this.form.warningDateField = ''
    }
    this.showNodeStatus = this.changeWarningDateField(this.form.warningDateField)
    this.warningRuleItemList = this.getFilterWarningRuleItemList()
    if (!this.form.warningRuleItemList || this.form.warningRuleItemList.length === 0) {
      this.form.warningRuleItemList = []
      this.onAdd()
    }
  },
  methods: {
    commitHandler() {
      this.fullscreenLoading = getLoading()
      this.form.syncTemplate = this.ignoreMode
      this.form.ignoreTime = this.form.ignoreTime || 0
      saveWarningRule(this.form).then((res) => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        commonUtil.objCopy(this.form, this.source)
        this.$emit('reload')
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    onAdd() {
      if (this.warningRuleItemList.length >= 3) {
        return
      }
      const len = 1 + (this.warningRuleItemList.length === 0 ? 1 : this.warningRuleItemList.length * 2)
      const item = {
        ruleItem: '1',
        duration: len * 24,
        action: 0,
        warningRuleUuid: this.form.uuid,
        level: 1,
        notifierRoles: '1,2',
        notifierIds: '',
        enableMail: 1,
        enableWeChat: 0,
        _ext: {
          hasDesignatedPost: true,
          hasNotifierIds: false
        }
      }
      this.form.warningRuleItemList.push(item)
      this.warningRuleItemList.push(item)
    },
    onRemove(item, index) {
      if (item.uuid) {
        item.action = 2
        this.warningRuleItemList.splice(index, 1)
      } else {
        this.warningRuleItemList.splice(index, 1)
        const index2 = this.form.warningRuleItemList.findIndex(p => p === item)
        if (index2 > -1) {
          this.form.warningRuleItemList.splice(index2, 1)
        }
      }
    },
    close() {
      this.$emit('close')
    },
    changeWarningDateField(val) {
      if (!val) {
        return false
      }
      const alertType = this.alertTypes.filter(item => item.code === val)
      if (!alertType || alertType.length === 0) {
        return false
      }
      return alertType[0].field === 'TRIGGER_TRACKING_DETAIL_UUID'
    },
    toArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    getFilterWarningRuleItemList() {
      const result = []
      if (this.form.warningRuleItemList) {
        for (let i = 0; i < this.form.warningRuleItemList.length; ++i) {
          let item = this.form.warningRuleItemList[i]
          if (item.action !== 2) {
            if (item._ext) {
              item._ext.hasDesignatedPost = !!item.notifierRoles
              item._ext.hasNotifierIds = !!item.notifierIds
            } else {
              item = {
                ...item,
                _ext: {
                  hasDesignatedPost: !!item.notifierRoles,
                  hasNotifierIds: !!item.notifierIds
                }
              }
              this.form.warningRuleItemList[i] = item
            }
            result.push(item)
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
  .warn-rule-form {
    .el-dialog__body {
      padding: 10px !important;
    }

    .primary-text {
      color: $--color-primary;
    }

    .content-wrapper {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      width: 360px !important;
      .custom {
        .el-form-item__content {
          width: auto;
        }
      }

      .el-radio__label{
        font-size: 12px;
      }
      .el-form-item__content {
        width: 240px !important;
        textarea {
          width: 240px;
        }
        .cargo-advance-select-wrapper{
          width: 240px !important;
        }
      }

      .form-operator {
        margin-left: 5px;
        margin-right: 5px;
        cursor: pointer;
        font-size: 18px;

        .el-icon-circle-plus {
          font-size: medium;
          color: $--color-success;
        }

        .el-icon-remove {
          font-size: medium;
          color: $--color-danger;
        }
      }
    }

    .el-scrollbar {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .el-scrollbar__bar.is-horizontal {
        display: none;
      }
    }
  }
</style>
